import { render } from "./myLess.vue?vue&type=template&id=dcf72330&scoped=true"
import script from "./myLess.vue?vue&type=script&lang=js"
export * from "./myLess.vue?vue&type=script&lang=js"

import "./myLess.vue?vue&type=style&index=0&id=dcf72330&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf72330"]])

export default __exports__